import React from 'react'
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

export const CardComponent = ({id, title, image, url}) => {
    return (
        <div key={id} className="card-album">
            <a href={url} target="_blank" rel="noopener noreferrer" title={title}>
                <LazyLoad height={150} width={150}>
                    <img width="150px" height="150px" className="card-album-image animate__fadeIn" src={image} alt={title} />
                </LazyLoad>
            </a>
            <h2 className="card-album-title">{title}</h2>
        </div>
    )
}

CardComponent.propTypes = {
    id: PropTypes.number,
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string
};